module.exports = __webpack_public_path__ + "background2.jpg";